import ProjectSettings from "./project-settings";
import {ViewType} from "../../../gd/const/views/view-type"
import ProjectViews from "../../../model2/project-view/project-views"
import ProjectView from "../../../model2/project-view/project-view"

export default class ProjectSettings_ViewsAppSettings {

    public projectSettings  : ProjectSettings

    constructor(projectSettings:ProjectSettings, config:any) {
        this.projectSettings = projectSettings

        this._initFromConfig(config)
    }

    _initFromConfig(config:any) {
        _.forEach(config, (appSettings, projectViewId) => {
            // @ts-ignore
            this[projectViewId] = appSettings
        })
    }

    getConfig(viewId:ID) {
        return _.get(this, viewId.toString(), null)
    }

    setConfig(viewId:any, config:any) {
        // @ts-ignore
        this[viewId] = config
    }

    getConfigByViewType(viewType: ViewType) {
        const parentProjectViews: ProjectViews = ProjectViews.initByProjectId(this.projectSettings.project.id)
        let config = null

        _.some(parentProjectViews.getBySystemType(viewType), (projectView: ProjectView) => {
            if (projectView.canBeInherited) {
                config = projectView.appSettingsConfig
                return !!config
            }
        })

        return config
    }

    toJSON() {
        let result : any = {}
        const views = this.projectSettings.project.getInheritedViews();

        _.forEach(views, projectView=>{
            const projectViewId = projectView.id?.toString();
            // @ts-ignore
            if (this[projectViewId]) result[projectViewId] = this[projectViewId]
        })

        if (_.isEmpty(result)) result = null

        return result
    }

}
